<template>
    <div class="background-circle-1">
        <svg width="1163" height="223" viewBox="0 0 1163 223" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect opacity="0.36" width="1163" height="1166" rx="581.5" fill="#CBD5FB"/>
        </svg>
    </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.background-circle-1 {
    display: flex;
    justify-content: center;

    svg {
        width: 100%;
    }
}
</style>
